import React, { useState, useContext } from 'react';
import { ShopContext } from '../context/shopcontext';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useEffect } from 'react';

const Login = () => {
  const [currentState, setCurrentState] = useState('Login');
  const { token, setToken, navigate, backendUrl } = useContext(ShopContext);

  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [loading, setLoading] = useState(false);

  const validatePassword = (password) => {
    const errors = [];
    if (password.length < 8) errors.push('at least 8 characters');
    if (!/[A-Z]/.test(password)) errors.push('one uppercase letter');
    if (!/[a-z]/.test(password)) errors.push('one lowercase letter');
    if (!/[0-9]/.test(password)) errors.push('one number');
    if (!/[!@#$%^&*]/.test(password)) errors.push('one special character');
    return errors;
  };

  const onPasswordChange = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);

    if (currentState === 'Sign Up') {
      const errors = validatePassword(newPassword);
      if (errors.length > 0) {
        setPasswordError(`Password must contain ${errors.join(', ')}`);
      } else {
        setPasswordError('');
      }
    }
  };

  const onSubmitHandler = async (event) => {
    event.preventDefault();
    if (loading) return; // ✅ Prevent double submit

    setLoading(true);
    if (currentState === 'Sign Up') {
      const errors = validatePassword(password);
      if (errors.length > 0) {
        toast.error('Please enter a strong password');
        setLoading(false);
        return;
      }
    }

    try {
      const url =
        currentState === 'Sign Up'
          ? `${backendUrl}/api/user/register`
          : `${backendUrl}/api/user/login`;

      const payload = currentState === 'Sign Up' ? { name, email, password } : { email, password };

      const response = await axios.post(url, payload, { withCredentials: true });

      if (response.data.success) {
        const { accessToken } = response.data;
        localStorage.setItem('token', accessToken);
        setToken(accessToken);
        navigate('/');
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } else if (error.message) {
        toast.error(error.message);
      } else {
        toast.error('Something went wrong. Please try again.');
      }
    } finally {
      setLoading(false); // ✅ Always reset loading
    }
  };

  useEffect(() => {
    if (token) {
      navigate('/');
    }
  }, [token]);

  return (
    <form
      onSubmit={onSubmitHandler}
      className="flex flex-col items-center w-[90%] sm:max-w-96 m-auto mt-28 gap-4 text-[#4c0f2e]"
    >
      <div className="inline-flex items-center gap-2 mb-2 mt-10">
        <p className="prata-regular text-3xl">{currentState}</p>
        <hr className="border-none h-[1.5px] w-8 bg-[#4c0f2e]" />
      </div>

      {currentState === 'Sign Up' && (
        <input
          onChange={(e) => setName(e.target.value)}
          value={name}
          type="text"
          className="w-full px-3 py-2 border border-[#b09287]"
          placeholder="Name"
          required
        />
      )}

      <input
        onChange={(e) => setEmail(e.target.value)}
        value={email}
        type="email"
        className="w-full px-3 py-2 border border-[#b09287]"
        placeholder="Email"
        required
      />

      <div className="w-full">
        <input
          onChange={onPasswordChange}
          value={password}
          type="password"
          className="w-full px-3 py-2 border border-[#b09287]"
          placeholder="Password"
          required
        />
        {passwordError && currentState === 'Sign Up' && (
          <p className="text-red-500 text-xs mt-1">{passwordError}</p>
        )}
      </div>

      <div className="w-full flex justify-between text-sm mt-[-8px]">
        <p onClick={() => navigate('/forgot-password')} className="cursor-pointer text-[#4c0f2e]">
          Forgot your password?
        </p>
        <p
          onClick={() => {
            setCurrentState(currentState === 'Login' ? 'Sign Up' : 'Login');
            setPasswordError('');
          }}
          className="cursor-pointer text-[#4c0f2e]"
        >
          {currentState === 'Login' ? 'Create account' : 'Login Here'}
        </p>
      </div>

      <button
        disabled={loading}
        className={`bg-[#4c0f2e] border border-[#b09287] shadow-md rounded-md text-white px-8 py-2 mt-4 ${
          loading ? 'opacity-50 cursor-not-allowed' : ''
        }`}
      >
        {loading ? 'Loading...' : currentState === 'Login' ? 'Sign In' : 'Sign Up'}
      </button>
    </form>
  );
};

export default Login;
